import React from "react";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default function CarouselComponent({ sliderItems }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const slides = sliderItems.map(item => {
    return (
      <div key={item.src}>
        <img className="d-block w-100" src={item.src} alt={item.altText} />
        <div className="carousel-caption">
          <h3>{item.caption}</h3>
        </div>
      </div>
    );
  });

  return <Slider {...settings}>{slides}</Slider>;
}
